module.exports = __webpack_public_path__ + "img/e1.476f59b1.jpg";